import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import invariant from 'invariant';
import { fade, makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Paper from '@material-ui/core/Paper';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    },
    filter: theme.mixins.gutters(_defineProperty({
      display: 'flex',
      flexGrow: 1
    }, theme.breakpoints.down('xs'), {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    })),
    actions: theme.mixins.gutters(_defineProperty({
      display: 'flex',
      flex: 0,
      alignItems: 'center'
    }, theme.breakpoints.down('xs'), {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    })),
    'active-button': {
      color: theme.palette.action.active,
      backgroundColor: fade(theme.palette.action.active, 0.12),
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, 0.15)
      }
    }
  };
}, {
  name: 'SxComProductListHeader'
});

function ProductListHeader(_ref) {
  var availableVariants = _ref.availableVariants,
      children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      displayVariant = _ref.displayVariant,
      elevation = _ref.elevation,
      onChangeDisplayVariant = _ref.onChangeDisplayVariant,
      rest = _objectWithoutProperties(_ref, ["availableVariants", "children", "classes", "className", "displayVariant", "elevation", "onChangeDisplayVariant"]);

  var defaultVariant = availableVariants.find(function (_ref2) {
    var v = _ref2.variant;
    return v === displayVariant;
  });
  invariant(defaultVariant, "Invalid variant ".concat(displayVariant, ". Please use one of ").concat(availableVariants.map(function (_ref3) {
    var v = _ref3.variant;
    return v;
  })));
  var classes = useStyles({
    classes: pClasses
  });

  var handleChangeViewVariant = function handleChangeViewVariant(vrnt) {
    return function () {
      onChangeDisplayVariant(vrnt);
    };
  };

  return /*#__PURE__*/React.createElement(Paper, _extends({
    elevation: elevation
  }, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.filter
  }, children), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(ButtonGroup, null, availableVariants.map(function (_ref4) {
    var ButtonComponent = _ref4.ButtonComponent,
        variant = _ref4.variant;
    return /*#__PURE__*/React.createElement(ButtonComponent, {
      key: variant,
      onClick: handleChangeViewVariant(variant),
      className: clsx(classes.button, displayVariant === variant && classes['active-button'])
    });
  }))));
}

ProductListHeader.propTypes = {
  availableVariants: PropTypes.arrayOf(PropTypes.shape({
    ButtonComponent: PropTypes.elementType,
    // tlacitko prepinace variant
    variant: PropTypes.string.isRequired // identifikator varianty

  })).isRequired,
  children: PropTypes.node,
  classes: PropTypes.shape({
    actions: PropTypes.string,
    'active-button': PropTypes.string,
    button: PropTypes.string,
    filter: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  displayVariant: PropTypes.string,
  elevation: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]),
  onChangeDisplayVariant: PropTypes.func
};
ProductListHeader.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined,
  displayVariant: 'card',
  elevation: 0,
  onChangeDisplayVariant: undefined
};
export default ProductListHeader;